import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { ContactEditComponentForAttendance } from './contact-edit/contact-edit.component';
import { AddLeadSourceComponent } from './add-lead-source/add-lead-source.component';
import { SoftphoneModule } from '../../../../softphone/softphone.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SoftphoneModule
  ],
  declarations: [
    ContactListComponent,
    ContactInfoComponent,
    ContactEditComponentForAttendance,
    AddLeadSourceComponent,
  ],
  exports: [
    ContactListComponent,
    ContactInfoComponent,
    ContactEditComponentForAttendance,
    AddLeadSourceComponent,
  ]
})
export class ContacttModule { }
